/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IAgentModerationInfo } from '../agent_moderation_info/AgentModerationInfo';
import type { ISocialNetwork } from '../social_network_type/SocialNetwork';
import type { ISocialProfiles } from '../social_profile_type/SocialProfiles';
import type { IPhone } from '../phone/Phone';

export interface IAgentForCardV2 {
  /** Время регистрации на ЦИАН **/
  age: string;
  /** Участвует в акции **/
  hasFairplay: boolean;
  /** Включены ли чаты **/
  isChatsEnabled: boolean;
  /** ID пользователя на Realty **/
  realtyUserId: number;
  /** Статус публикации **/
  status: EStatus;
  /** Статус пользователя **/
  userStatus: EUserStatus;
  /** Статус участия в РГР **/
  hasRgrParticipation: boolean;
  /** Входит в ассоциацию КОКОН **/
  hasKokonParticipation?: TAgentForCardV2_HasKokonParticipation;
  /** Тип аккаунта **/
  accountType?: TAgentForCardV2_AccountType;
  /** Абсолютный URL до аватара **/
  avatarUrl?: TAgentForCardV2_AvatarUrl;
  /** Место работы, если тип агента специалист **/
  companyName?: TAgentForCardV2_CompanyName;
  /** Контактный email указанный агентом **/
  contactEmail?: TAgentForCardV2_ContactEmail;
  /** "обо мне" профиля агента **/
  description?: TAgentForCardV2_Description;
  /** Текстовое описание с какого кода работает **/
  experience?: TAgentForCardV2_Experience;
  /** Пользователь на тарифе "Застройщик" **/
  isDeveloper?: TAgentForCardV2_IsDeveloper;
  /** Аватар мастер агента **/
  miniAvatarUrl?: TAgentForCardV2_MiniAvatarUrl;
  /** Информация от модерации **/
  moderationInfo?: TAgentForCardV2_ModerationInfo;
  /** Имя агента **/
  name?: TAgentForCardV2_Name;
  /** Регион работы **/
  regionsNames?: TAgentForCardV2_RegionsNames;
  /** Специализация **/
  skills?: TAgentForCardV2_Skills;
  /** Skype пользователя **/
  skype?: TAgentForCardV2_Skype;
  /** Социальные сети через ID в них **/
  socialNetworks?: TAgentForCardV2_SocialNetworks;
  /** Социальные сети через ссылки на профиль **/
  socialProfiles?: TAgentForCardV2_SocialProfiles;
  /** Ссылка на вебсайт **/
  website?: TAgentForCardV2_Website;
  /** Подменный номер телефона **/
  ctPhoneNumber?: TAgentForCardV2_CtPhoneNumber;
  /** Номера телефонов **/
  phones?: TAgentForCardV2_Phones;
}

export enum EStatus {
  /** Скрыто **/
  Hidden = 'hidden',
  /** Опубликовано **/
  Published = 'published',
}
export enum EUserStatus {
  /** Активный **/
  Active = 'active',
  /** Заблокированный **/
  Blocked = 'blocked',
  /** Удаленный **/
  Deleted = 'deleted',
}
export type TAgentForCardV2_HasKokonParticipation = null | boolean;

export type TAgentForCardV2_AccountType = null | EAccountType;

export enum EAccountType {
  /** Агенство **/
  Agency = 'agency',
  /** Управляющая компания **/
  ManagementCompany = 'managementCompany',
  /** Отдел аренды **/
  RentDepartment = 'rentDepartment',
  /** Специалист **/
  Specialist = 'specialist',
}
export type TAgentForCardV2_AvatarUrl = null | string;

export type TAgentForCardV2_CompanyName = null | string;

export type TAgentForCardV2_ContactEmail = null | string;

export type TAgentForCardV2_Description = null | string;

export type TAgentForCardV2_Experience = null | string;

export type TAgentForCardV2_IsDeveloper = null | boolean;

export type TAgentForCardV2_MiniAvatarUrl = null | string;

export type TAgentForCardV2_ModerationInfo = null | IAgentModerationInfo;

export type TAgentForCardV2_Name = null | string;

export type TAgentForCardV2_RegionsNames = null | string[];

export type TAgentForCardV2_Skills = null | string[];

export type TAgentForCardV2_Skype = null | string;

export type TAgentForCardV2_SocialNetworks = null | TAgentForCardV2_SocialNetworks_1;

export type TAgentForCardV2_SocialNetworks_1 = ISocialNetwork[];

export type TAgentForCardV2_SocialProfiles = null | TAgentForCardV2_SocialProfiles_1;

export type TAgentForCardV2_SocialProfiles_1 = ISocialProfiles[];

export type TAgentForCardV2_Website = null | string;

export type TAgentForCardV2_CtPhoneNumber = null | string;

export type TAgentForCardV2_Phones = null | TAgentForCardV2_Phones_1;

export type TAgentForCardV2_Phones_1 = IPhone[];
